<template>
  <div>
    <v-card>
      <v-card-title>
        Listado de Productos
        <v-spacer></v-spacer>
        <v-btn
          class="ma-2"
          color="orange"
          fab
          small
          dark
          :loading="loadingExcel"
          @click="_listaExcel()"
        >
          <v-icon>mdi-file</v-icon>
        </v-btn>
        <v-btn class="ma-2" color="green" fab small dark @click="_nuevo()">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <Listado
          :datos="datos"
          :encabezados="encabezados"
          :acciones="acciones"
        ></Listado>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import Listado from "@/components/Listado.vue";
var FileSaver = require("file-saver");
export default {
  name: "Productos_Listado",
  components: {
    Listado,
  },
  data() {
    return {
      datos: "/productos",
      encabezados: [
        {
          text: "Codigo",
          align: "start",
          value: "codigo",
        },
        { text: "Nombre", value: "nombre" },
        { text: "Categoria", value: "categoria.nombre" },
        { text: "Precio", value: "precio" },
        { text: "Stock", value: "stock" },
        {
          text: "Acciones",
          value: "acciones",
        },
      ],
      acciones: {
        editar: "/productos/",
      },
      loadingExcel: false
    };
  },
  methods: {
    _nuevo() {
      this.$router.push(`/productos/nuevo`);
    },
    async _listaExcel() {
      this.loadingExcel = true
      try {
        const excel = await this.axios.get("/productos/listaExcel", { responseType: 'blob' });
        FileSaver.saveAs(excel.data, `Lista de Precios ${this.$moment().format('DD-MM-YYYY')}.xls`);
      } catch (error) {
        console.log(error);
      }
      this.loadingExcel = false
    },
  },
};
</script>
